import React from 'react';
import AppLayout from '../components/AppLayout';
import ContentSearch from '../components/DataFiles/ContentSearch';

function SearchDocumentPage() {
  return (
    <>
      <AppLayout />
      <ContentSearch />
    </>
  );
}

export default SearchDocumentPage;
